import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";

import {
  useDiscountCode,
  WrapperModalDiscountCode,
} from "../../../../modules/discountCode";
import { DiscountCodeForm } from "../../../../modules/discountCode/ui/form";
import { DataDiscountCode } from "../../../../redux/@types";

import {
  selectDiscountCodeForUpdate,
  selectIsUpdateDiscountCode,
  selectModalDiscountCode,
} from "../../../../redux/selectors/discountCode.selectors";

export const ModalDiscountCode = () => {
  const modalDiscountCode = useSelector(selectModalDiscountCode);
  const isUpdateDiscountCode = useSelector(selectIsUpdateDiscountCode);
  const updateDiscountCode = useSelector(selectDiscountCodeForUpdate);

  const { isLoading, changeModalDiscountCodeState, onSubmitCreateOrUpdate } =
    useDiscountCode();

  const { handleSubmit: onSubmit } = useFormContext<DataDiscountCode>();

  const drawerTitle = isUpdateDiscountCode
    ? `Editar cupón: ${updateDiscountCode?.name ?? updateDiscountCode?.id}`
    : "Nuevo cupón de descuento";

  return (
    <WrapperModalDiscountCode
      title={<span style={{ fontSize: 18, fontWeight: 600 }}>{drawerTitle}</span>}
      open={modalDiscountCode}
      width={520}
      destroyOnClose
      onClose={changeModalDiscountCodeState}
      headerStyle={{ borderBottom: "1px solid #f0f0f0", padding: "16px 24px" }}
      bodyStyle={{ padding: "24px", background: "#fafafa" }}
    >
      <DiscountCodeForm
        isUpdate={isUpdateDiscountCode}
        isLoading={isLoading}
        onSubmit={onSubmit(onSubmitCreateOrUpdate)}
      />
    </WrapperModalDiscountCode>
  );
};
